import script from "./ContentSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentSidebar.vue?vue&type=script&setup=true&lang=js"

import "./ContentSidebar.vue?vue&type=style&index=0&id=01c521aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01c521aa"]])

export default __exports__